import { AMPEL_KLASSEN, AMPEL_TEXT, GEPRUEFT, ampel, prozent, type Ampel } from "../lib/konfidenz";

export function AmpelPunkt({ stufe, gross = false }: { stufe: Ampel; gross?: boolean }) {
  return <span aria-hidden className={`inline-block shrink-0 rounded-full ${gross ? "h-3 w-3" : "h-2.5 w-2.5"} ${AMPEL_KLASSEN[stufe].punkt}`} />;
}

/** Kompakte Anzeige: Punkt + Prozent (oder „geprüft“). */
export function KonfidenzAnzeige({ konfidenz, hatWert = true }: { konfidenz: number | undefined; hatWert?: boolean }) {
  if (konfidenz !== undefined && konfidenz >= GEPRUEFT) {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-semibold text-ampel-gruen" title="Vom Sachbearbeiter geprüft">
        ✓ geprüft
      </span>
    );
  }
  const stufe = ampel(konfidenz, hatWert);
  const text = !hatWert ? "nicht erkannt" : stufe === "keine" ? "manuell" : prozent(konfidenz);
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-semibold ${AMPEL_KLASSEN[stufe].text}`}
      title={`Konfidenz: ${AMPEL_TEXT[stufe]}`}
    >
      <AmpelPunkt stufe={stufe} />
      {text}
    </span>
  );
}

export function KonfidenzLegende({ kompakt = false }: { kompakt?: boolean }) {
  const eintraege: [Ampel, string][] = [
    ["gruen", "> 80 % sicher erkannt"],
    ["gelb", "50–80 % bitte prüfen"],
    ["rot", "< 50 % unsicher / fehlt"],
  ];
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-neutral-600 ${kompakt ? "" : "rounded-lg bg-neutral-50 px-3 py-2"}`}>
      <span className="font-semibold text-neutral-800">Konfidenz:</span>
      {eintraege.map(([stufe, text]) => (
        <span key={stufe} className="inline-flex items-center gap-1.5">
          <AmpelPunkt stufe={stufe} />
          {text}
        </span>
      ))}
      <span className="inline-flex items-center gap-1 font-semibold text-ampel-gruen">✓ geprüft = vom Menschen bestätigt</span>
    </div>
  );
}
